//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavProjectsFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2 2H22V22H2V2ZM17 13V15C17 16.1046 16.1046 17 15 17H13V13H17ZM11 13H7V15C7 16.1046 7.89543 17 9 17H11V13ZM13 7H15C16.1046 7 17 7.89543 17 9V11H13V7ZM9 7C7.89543 7 7 7.89543 7 9V11H11V7H9Z" fill="currentColor" /></svg>;
}
export default IconNavProjectsFill;